import { createItem } from '@/trendData/itemStore.utilities';
import { ITEM_TYPES } from '@/trendData/trendData.constants';
import type { StatisticsSummaryItem } from '@/summaryReport/summaryData.types';
import type { SummaryReportDehydratedState, SummaryReportState } from '@/summaryReport/summaryReport.store';

export const asFormulaItem = (item: StatisticsSummaryItem): StatisticsSummaryItem => ({
  ...item,
  itemType: ITEM_TYPES.FORMULA_ITEM,
});

export function rehydrateSummaryReportState(
  dehydratedState: Partial<SummaryReportDehydratedState>,
  setState: (state: Partial<SummaryReportState>) => void,
): void {
  const items = (dehydratedState.items ?? []).map((item) => {
    // Older persisted worksheets may still carry a stray itemType; strip it so it can't
    // override the FORMULA_ITEM stamp below (createItem merges props in last).
    const { id, name, itemType: _itemType, ...itemProps } = item as typeof item & { itemType?: unknown };
    return createItem(item.id, item.name, ITEM_TYPES.FORMULA_ITEM as Parameters<typeof createItem>[2], itemProps);
  });

  const { items: _items, isItemsOverlaid, ...restState } = dehydratedState;
  setState({
    ...restState,
    items: items as SummaryReportState['items'],
    isItemsOverlaid: Boolean(isItemsOverlaid) && items.length > 1,
  });
}
